module.exports = __webpack_public_path__ + "static/media/birdy2.326f8cd3.gif";